module.exports = __webpack_public_path__ + "static/img/c5.cbec78f7.svg";